<template>
  <div>
    <validation-provider
      v-if="isValidation"
      :rules="`required|isInvalid:${pkId}`"
      v-slot="{ validated, valid, errors }"
      slim
      :name="labelName"
      class="inputSelectValidation"
    >
      <b-form-group :label="labelName" :invalid-feedback="errors[0]" label-sr-only>
        <b-form-input
          autocomplete="off"
          :ref="nameItem"
          v-model.trim="inputVal"
          class="inputSelect"
          :list="nameItem"
          :state="validated ? valid : null"
          :placeholder="labelName"
          @input="changeId"
        ></b-form-input>
        <datalist :id="nameItem">
          <option
            ref="option"
            v-for="(item, index) in optionData"
            :key="index"
            :id="type === 'og' ? item.ogId : ''"
            :text="item.piRaId"
          >
            {{ type === 'og' ? item.ogName : '' }}
          </option>
        </datalist>
      </b-form-group>
    </validation-provider>
    <div class="inputSelect" v-if="!isValidation">
      <b-form-group
        :label="labelName"
        label-cols="4"
        label-cols-sm="3"
        label-cols-md="auto"
        label-class="text-secondary"
      >
        <b-form-input
          autocomplete="off"
          :ref="nameItem"
          v-model.trim="inputVal"
          class="inputSelect position-relative"
          :list="nameItem"
          @input="changeId"
        ></b-form-input>
        <datalist :id="nameItem">
          <option
            ref="option"
            v-for="(item, index) in optionData"
            :key="index"
            :id="type === 'og' ? item.ogId : '' || type === 'pi' ? item.piId : ''"
          >
            {{ type === 'og' ? item.ogName : '' || type === 'pi' ? item.piName : '' }}
          </option>
        </datalist>
      </b-form-group>
    </div>
  </div>
</template>
<script>
export default {
  name: 'InputSelect',
  props: {
    // 判斷是否為 驗證ipnut
    isValidation: {
      type: Boolean,
      default: false,
    },

    // ref 名稱
    nameItem: {
      type: String,
      default: '',
    },

    // 選單資料
    optionData: {
      type: Array,
      default() {
        return [];
      },
    },

    // 驗證規則
    rules: {
      type: String,
      default: '',
    },

    // input label名字 or 提示字使用
    labelName: {
      type: String,
      default: '',
    },

    // input值
    val: {
      type: String,
      default: '',
    },

    // input id
    pk: [String, Number],

    // 用來判斷 id 跟 input值
    type: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      inputVal: this.val,
      pkId: this.pk,
    };
  },
  mounted() {
    this.updateInputVal();
    this.$emit('inputPkId', this.pkId, this.inputVal);
  },
  methods: {
    changeId() {
      const val = this.inputVal;
      if (
        this.$refs.option !== null &&
        this.$refs.option !== '' &&
        this.$refs.option !== undefined
      ) {
        const option = this.$refs.option.filter(function (e) {
          return e.value.trim() === val.trim();
        });
        if (option.length === 0) {
          this.pkId = null;
          this.$emit('inputPkId', this.pkId);
        } else {
          this.pkId = option[0].id;
          if (option[0].attributes.text) {
            this.$emit('inputPkId', this.pkId, this.inputVal, option[0].attributes.text.value);
          } else {
            this.$emit('inputPkId', this.pkId, this.inputVal, '');
          }
        }
        if (val === '') {
          this.pkId = null;
          this.$emit('inputPkId', this.pkId);
        }
      } else if (this.$refs.option === undefined) {
        this.$emit('inputPkId', (this.pkId = null), this.inputVal);
      } else {
        this.$emit('inputPkId', (this.pkId = null), (this.inputVal = null));
      }
      console.log('結果:', this.pkId);
    },
    errFeedback(val) {
      this.$refs[`${this.nameItem}`].$el.className = val;
    },
    sussFeedback(val) {
      this.pkId = val;
      console.log('sussFeedback:this.pkId--', this.pkId, this.inputVal);
      this.$emit('inputPkId', this.pkId, this.inputVal);
    },
    inputValClear() {
      this.inputVal = null;
    },
    updateInputVal() {
      this.inputVal = this.val;
      this.pkId = this.pk;
    },
  },
};
</script>
